export const initialState = {};

export const STORE_NAME = 'WALLET';
